import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit }, typography: { text } }) => ({
  wrapper: {
    margin: `${unit * 2}px 0 0`,
    '& fieldset': {
      margin: 0,
      alignItems: 'center',
      display: 'flex',
      '& > div': {
        margin: `0 ${unit}px 0 0`
      },
      '& > input': {
        margin: `0 ${unit * 1.5}px 0 0`
      },
      '& > label': {
        margin: `0 ${unit * 2.5}px 0 0`,
        lineHeight: `${unit * 2}px`
      }
    },
    '& legend > p': {
      ...text,
      textTransform: 'none'
    }
  }
});

export default createUseStyles(styles);
